<template lang="pug">
  el-dialog(title="查看详情", :close-on-click-modal='false', :visible.sync='visible' width="95%" :modal-append-to-body='false')
    el-form(:model='dataForm', :inline='false' ref='dataForm',label-suffix=":"  label-width='80px')
      el-form-item(label='标题')
        <span>{{dataForm.title1}}</span>
      el-form-item(label='摘要')
        <span>{{dataForm.summary}}</span>
      el-form-item(label='主办方')
        <span>{{dataForm.orgName}}</span>
      el-form-item(label='发布日期')
        <span>{{dataForm.date.slice(0,10)}}</span>
      el-form-item(label='缩略图')
        img(v-if="imageUrl" :src="imageUrl" class="avatar" )
        img(v-else src="../../mb/img/img.jpg" class="avatar" )
      el-form-item(label='正文内容')
        <div v-html="dataForm.content" ></div>
    span.dialog-footer(slot='footer')
      el-button(@click='visible = false') 返回
</template>

<script>
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        id: '',
        title1: '',
        date: '',
        type: '',
        orgName: '',
        orgId: '',
        is_top: '',
        summary: '',
        content: '',
        headImg: ''
      },
      imageUrl: ''
    }
  },
  computed: {
    addressName: function () {
      if (this.dataForm.proviceName == this.dataForm.cityNames) {
        return this.dataForm.proviceName
      } else {
        return this.dataForm.proviceName + '' + this.dataForm.cityNames
      }
    }
  },
  methods: {
    init1 (row) {
      this.visible = true
      console.log(row)
      if (row) {
        this.dataForm.id = row.id
      }
      this.dataForm.title1 = row.title
      this.dataForm.date = row.publishTime
      this.dataForm.type = this.leixing(row.type)
      this.dataForm.orgName = row.orgName
      this.dataForm.is_top = row.isTop == 1 ? '是' : '否'
      this.dataForm.summary = row.summary
      // this.dataForm.content = row.content
      if (this.dataForm.id) {
        this.$http({
        url: this.$http.adornUrl(`/pbNews/getId/${this.dataForm.id}`),
        method: 'get',
        params: this.$http.adornParams()
        }).then((data) => {
          if (data && data.code === 0) {
              if (data.bean.imgUrl != '' && data.bean.imgUrl != null) {
                this.imageUrl = data.bean.imgUrl
              }
              this.dataForm.content = data.bean.content
          }
        })
      }
    },
    leixing (val) {
      let obj = {
        1: '培训',
        2: '禁赛',
        3: '活动',
        4: '专栏',
        5: '图片直播'
      }
      if (obj[val]) return obj[val]
      return ''
    }
  }
 }
</script>
<style >

  .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }
    .avatar {
        width: 240px;
        height: 174px;
        display: block;
    }
</style>
